var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group",class:( _obj = {}, _obj[("elements-" + _vm.elements)] = true, _obj )},[_vm._t("button"),_vm._t("input")],2)}
var staticRenderFns = []

export { render, staticRenderFns }